import { formatDateTimeForAPI } from './DateFormatting';
import {
  ONE_MINUTE,
  TWENTY_FOUR_HOURS,
  SIXTY_MINUTES,
  SEVEN_DAYS,
  ONE_MONTH,
} from '../components/RelativeDateAndTime/constants/index';

/**
 *
 * @param { Object } dateObj
 * @param {Object } anchorDate - the anchor date the date field has subscribed to (if relative)
 * @param { Number } eventId
 * @return { Object } a date object with the difference in seconds, comaptible with api
 *
 *
 * When user selects ON anchor - value is 0, operator is =
 * When user selects On anchor AND specificTime, value is still 0 but AbsoluteTime is True
 */

export const formatSaveRDAT = (dateObj, anchorDate, eventId) => {
  let RelativeDate = {};
  const data = {};

  let DateTime = '';

  if (dateObj.hasOwnProperty('dateTime')) {
    DateTime = dateObj.dateTime ? formatDateTimeForAPI(dateObj.dateTime) : '';
  } else {
    DateTime = dateObj.date ? formatDateTimeForAPI(dateObj.date) : '';
  }

  // check added for price codes ^ bc empty price codes dates are valid
  const FieldId = dateObj.fieldId;
  const EventId = eventId;
  Object.assign(data, { DateTime }, { FieldId }, { EventId });
  if (!dateObj.isRelative && dateObj.id) {
    Object.assign(RelativeDate, { Id: dateObj.id });
    return Object.assign(data, { RelativeDate });
  }

  if (dateObj.isRelative) {
    const diffInSeconds = calculateDifferenceInSeconds(dateObj);
    RelativeDate = {
      AnchorFieldId: anchorDate.fieldId,
      IsAbsoluteTime: Boolean(dateObj.specificTime),
      Value: diffInSeconds,
      Operator: determineOperator(dateObj),
    };
    if (dateObj.id) {
      Object.assign(RelativeDate, { Id: dateObj.id });
    }
    Object.assign(data, { RelativeDate });
  }

  return data;
};

export const determineSecondsValue = (occurrence, diffInSeconds) => {
  const firstWord = occurrence.name.split(' ')[0].toLowerCase();
  return firstWord === 'on' ? 0 : Math.abs(diffInSeconds);
};

/**
 *
 * @param { Object } - dateObj - Front end Date Object
 * @return { String } - operator - either =, < or >
 */
export const determineOperator = (dateObj) => {
  const firstWord = dateObj.occurrence.name.split(' ')[0].toLowerCase();

  if (firstWord === 'on') {
    return '=';
  } else if (firstWord === 'before') {
    return '<';
  }
  return '>';
};

export const convertMinutesToSeconds = (timeUnitAmount) => {
  return timeUnitAmount * 60;
};
export const convertHoursToSeconds = (timeUnitAmount) => {
  return timeUnitAmount * 60 * 60;
};
export const convertDaysToSeconds = (timeUnitAmount) => {
  return timeUnitAmount * 24 * 60 * 60;
};
export const convertWeeksToSeconds = (timeUnitAmount) => {
  return timeUnitAmount * 7 * 24 * 60 * 60;
};
export const calculateDifferenceInSeconds = (dateObj) => {
  return (
    dateObj.months * ONE_MONTH +
    dateObj.weeks * SEVEN_DAYS +
    dateObj.days * TWENTY_FOUR_HOURS +
    dateObj.hours * SIXTY_MINUTES +
    dateObj.minutes * ONE_MINUTE
  );
};

export const formatAnchorDate = (anchorDate, eventId) => {
  return {
    DateTime: anchorDate.date,
    FieldId: anchorDate.fieldId,
    EventId: eventId,
  };
};

export const formatRelativeDate = (
  dateObj,
  eventStartDate,
  generalOnsaleDate,
  eventId,
  eventEndDate
) => {
  if (dateObj) {
    const anchorDate =
      Number(dateObj.anchor) === 1
        ? eventStartDate
        : Number(dateObj.anchor) === 2
        ? eventEndDate
        : generalOnsaleDate;
    return formatSaveRDAT(dateObj, anchorDate, eventId);
  }
};



// WEBPACK FOOTER //
// ./src/common/lib/formatSaveRDAT.js